(() => {
  const initialize = (root) => {
    if (root.dataset.dbInstallmentsReady === 'true') return;
    root.dataset.dbInstallmentsReady = 'true';

    const variantsElement = root.querySelector('[data-db-installment-variants]');
    const amounts = root.querySelectorAll('[data-db-installment-amount]');
    if (!variantsElement || !amounts.length) return;

    let variants;
    try {
      variants = JSON.parse(variantsElement.textContent);
    } catch {
      return;
    }
    if (!Array.isArray(variants)) return;

    const region = root.closest('product-info, .db-gt2000, .db-v10, .db-emoto-product, .dol-quad-product, .dol-premium-product') || root.parentElement;
    const formatter = new Intl.NumberFormat(root.dataset.locale || 'nl-NL', {
      style: 'currency',
      currency: root.dataset.currency || 'EUR',
    });
    const updateAmount = (variant) => {
      if (!variant || !Number.isFinite(Number(variant.price))) return;
      const installment = formatter.format(Math.round(Number(variant.price) / 3) / 100);
      amounts.forEach((amount) => { amount.textContent = installment; });
    };
    const updateFromVariantId = (variantId) => {
      const variant = variants.find((entry) => String(entry.id) === String(variantId));
      if (variant) updateAmount(variant);
    };

    region.addEventListener('change', (event) => {
      if (event.target.matches('[name="id"]')) updateFromVariantId(event.target.value);
    });
    window.addEventListener('popstate', () => {
      updateFromVariantId(new URL(window.location.href).searchParams.get('variant'));
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        if (String(event?.data?.sectionId) === root.dataset.sectionId) {
          updateAmount(event.data.variant);
        }
      });
    }
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll('[data-db-product-installments]').forEach(initialize);
  };

  initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
